$('.products table').wrap("<div class='table-overflow'></div>");